var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 47C41.6274 47 47 41.6274 47 35C47 28.3726 41.6274 23 35 23C28.3726 23 23 28.3726 23 35C23 41.6274 28.3726 47 35 47Z",
    stroke: "#ACB5BF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.86 31.14L31.14 38.85",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.86 38.85L31.14 31.14",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3092_2010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.13 44.48H4.88L5.84 42.62H20.99C20.72 42.1 20.48 41.56 20.26 41.01H3.23C2.34 41.01 1.62 40.29 1.62 39.4V11.17C1.62 10.28 2.34 9.56 3.23 9.56H26.64C27.53 9.56 28.25 10.28 28.25 11.17V21.72C28.78 21.48 29.31 21.26 29.86 21.08V11.17C29.86 9.39 28.41 7.94 26.63 7.94H20.05L21.11 2.61H22.41L23.93 4.99L25.29 4.12L23.29 1H6.57L4.57 4.12L5.93 4.99L7.45 2.62H8.72L9.78 7.95H3.23C1.45 7.95 0 9.4 0 11.18V39.39C0 41.17 1.45 42.62 3.23 42.62H4.02L1.79 46.95L3.22 47.69L4.04 46.1H23.44C22.97 45.59 22.53 45.05 22.13 44.49V44.48ZM19.47 2.61L18.41 7.94H11.43L10.37 2.61H19.47V2.61Z",
    fill: "#ACB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.81 30.84H1.69V32.45H19.36C19.47 31.9 19.63 31.36 19.8 30.84H19.81Z",
    fill: "#ACB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44 36.83C4.44 38.49 5.79 39.84 7.45 39.84C9.11 39.84 10.46 38.49 10.46 36.83C10.46 35.17 9.11 33.82 7.45 33.82C5.79 33.82 4.44 35.17 4.44 36.83V36.83ZM8.84 36.83C8.84 37.6 8.21 38.22 7.45 38.22C6.69 38.22 6.06 37.59 6.06 36.83C6.06 36.07 6.69 35.44 7.45 35.44C8.21 35.44 8.84 36.07 8.84 36.83Z",
    fill: "#ACB5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.18 13.23H1.69V14.84H28.18V13.23Z",
    fill: "#ACB5BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3092_2010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.87,
    height: 46.69,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainCancel);
export default __webpack_public_path__ + "static/media/train-cancel.53ffa12cce06bcd9ed4081a1d3562e1d.svg";
export { ForwardRef as ReactComponent };